export interface PlayerObserver {
    subscribe: (callback: () => void) => () => void;
    notify: () => void;
}

export const createPlayerObserver = (delay = 100): PlayerObserver => {
    const subscribers = new Set<() => void>();
    let lastNotify = 0;

    return {
        subscribe: (callback) => {
            subscribers.add(callback);

            return () => {
                subscribers.delete(callback);
            };
        },
        notify: () => {
            const now = Date.now();
            if (now - lastNotify >= delay) {
                subscribers.forEach((callback) => callback());
                lastNotify = now;
            }
        },
    };
};
